// extracted by mini-css-extract-plugin
module.exports = {"root":"PlayPauseButton_root__Tzyma","icon":"PlayPauseButton_icon__q7bU3"};